import type { AppointmentQueryParams, ViewMode } from '../types';

interface BuildAppointmentQueryParamsOptions {
  currentDate: Date;
  hasOrgScheduleAccess: boolean;
  isOrgViewActive: boolean;
  selectedPatientIds: string[];
  selectedProviderIds: string[] | null;
  viewMode: ViewMode;
}

/** Build the launched calendar's schedule-events query for the active view. */
export const buildAppointmentQueryParams = ({
  currentDate,
  hasOrgScheduleAccess,
  isOrgViewActive,
  selectedPatientIds,
  selectedProviderIds,
  viewMode,
}: BuildAppointmentQueryParamsOptions): AppointmentQueryParams => {
  const start = new Date(currentDate);
  const end = new Date(currentDate);

  if (viewMode === 'day') {
    start.setHours(0, 0, 0, 0);
    end.setHours(23, 59, 59, 999);
  } else if (viewMode === 'week') {
    const day = currentDate.getDay();
    start.setDate(currentDate.getDate() - day);
    start.setHours(0, 0, 0, 0);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);
  } else if (viewMode === 'month') {
    start.setDate(1);
    start.setHours(0, 0, 0, 0);
    end.setFullYear(currentDate.getFullYear());
    end.setMonth(currentDate.getMonth() + 1, 0);
    end.setHours(23, 59, 59, 999);
  }

  const params: AppointmentQueryParams = {
    start_date: start.toISOString(),
    end_date: end.toISOString(),
    include_cancelled: true,
  };

  if (hasOrgScheduleAccess && isOrgViewActive) {
    if (selectedProviderIds === null) {
      // null = uninitialized (pre-clinician-load), fetch all until initialized
      params.all_providers = true;
    } else if (selectedProviderIds.length > 0) {
      params.provider_ids = selectedProviderIds;
    }
    // [] = user deselected all -> no provider params -> no results
    if (selectedPatientIds.length > 0) {
      params.patient_ids = selectedPatientIds;
    }
  }

  return params;
};
